<template>
  <div>
    <v-dialog :modelValue="dialog_view" max-width="900" @click:outside="close" @keydown.esc="close">
      <v-card>
        <v-card-title class="headline"> Expedir orden de envío #{{ shipment_order?.code }}  </v-card-title>

        <v-card-text>
          <div class="row">
            <div class="col-md-12">
              <p style="color: red">Seleccione los LPNs que desea expedir de la orden de envío. Los LPNs no seleccionados serán desasociados del envío para poder almacenarlos nuevamente.</p>
              <div class="mb-3">
                <v-btn :color="allExpanded ? 'blue-grey' : 'blue-grey'" variant="outlined" size="small" @click="toggleExpandAll" class="mr-3">
                  <v-icon start>{{ allExpanded ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                  {{ allExpanded ? "Contraer Todo" : "Expandir Todo" }}
                </v-btn>
              </div>

              

              <v-data-table
                :headers="headers" 
                :items="list" 
                :search="search" 
                :loading="loading" loading-text="Cargando..." 
                :hide-default-footer="true" 
                v-model="selected" 
                :show-select="false" 
                v-model:select-all="toggleSelectAll"
                item-value="lpn.id"
                :items-per-page="1000"
              >
                <template v-slot:item="{ item, index, isSelected, toggleSelect }">
                  <tr :class="{ 'bg-grey-lighten-4': item.lpn.state.id == lpnService.STATE_SHIPPED }">                    
                    <td>
                      <v-btn variant="text" size="small" @click="toggleExpand(index)" icon v-if="item.lpn.state.id != lpnService.STATE_SHIPPED">
                        <v-icon>{{ isExpanded(index) ? "mdi-chevron-down" : "mdi-chevron-right" }}</v-icon>
                      </v-btn>
                    </td>

                    <td class="pl-2" v-if="isEmployee">
                      <v-checkbox
                        v-if="item.lpn.state.id != lpnService.STATE_SHIPPED"
                        :disabled="item.lpn.state.id == lpnService.STATE_SHIPPED"
                        style="margin: 0px; padding: 0px"
                        hide-details
                        :model-value="isSelected({ value: item.lpn.id })"
                        @update:modelValue="toggleSelect({ value: item.lpn.id })"
                      />
                    </td>

                    <td>{{ item.lpn.code }}</td>
                    <td>
                      <v-chip size="small" class="mt-1">{{ item.lpn.state.name }}</v-chip>
                    </td>
                    <td>{{ item.ubicacion?.code }}</td><!--puede que no tenga porque esta expedido-->
                  </tr>
                  <tr v-if="isExpanded(index)" :key="`expanded-${index}`">
                    <td :colspan="headers.length" class="pa-0">
                      <div class="pa-4 bg-grey-lighten-5">
                        <h6 class="mb-3">Productos del envio en este LPN</h6>
                        <div v-for="(assignedLocation, alIndex) in getFilteredAssignedLocations(item)" :key="alIndex" class="mb-3">
                          <v-card variant="outlined" class="mb-2" style="border-color: #e0e0e0 !important; border-width: 1px">
                            <v-card-text class="py-3">
                              <v-row>
                                <v-col cols="12" md="5">
                                  <span class="pb-1 text-caption">Producto</span>
                                  <div class="font-weight-medium">{{ assignedLocation.presentation_atributes.product_presentation.product.name }}</div>
                                  <div class="text-caption text-grey-600">SKU: {{ assignedLocation.presentation_atributes.product_presentation.product.sku }}</div>
                                </v-col>
                                <v-col cols="12" md="2">
                                  <span class="pb-1 text-caption">Cantidad</span>
                                  <div class="d-flex align-center font-weight-bold">
                                    <div class="text-stock" style="min-width: 0px !important">
                                      {{ assignedLocation.available_stock }}
                                    </div>
                                    <div class="text-caption text-grey-600 flex-shrink-0 mt-1 presentation-type">
                                      {{
                                        getPresentationTypeName(
                                          assignedLocation.available_stock,
                                          assignedLocation.presentation_atributes.product_presentation.presentation_type.id,
                                          assignedLocation.presentation_atributes.product_presentation.presentation_type.name
                                        )
                                      }}
                                    </div>
                                  </div>
                                </v-col>
                                <v-col cols="12" md="5">
                                  <!-- <span class="font-weight-bold pb-1 text-caption">Atributos</span> -->
                                  <v-row class="ma-0">
                                    <v-col
                                      cols="6"
                                      class="pt-0"
                                      v-if="assignedLocation.presentation_atributes.product_presentation.product.tiene_control_por_lotes && assignedLocation.presentation_atributes.lote"
                                    >
                                      <div class="text-caption">Lote</div>
                                      <div class="text-caption">{{ assignedLocation.presentation_atributes.lote }}</div>
                                    </v-col>
                                    <v-col
                                      cols="6"
                                      class="pt-0"
                                      v-if="assignedLocation.presentation_atributes.product_presentation.product.tiene_control_por_serie && assignedLocation.presentation_atributes.serie"
                                    >
                                      <div class="text-caption">Serie</div>
                                      <div class="text-caption">{{ assignedLocation.presentation_atributes.serie }}</div>
                                    </v-col>
                                    <v-col
                                      cols="6"
                                      class="pt-0"
                                      v-if="assignedLocation.presentation_atributes.product_presentation.product.requiere_fecha_expiracion && assignedLocation.presentation_atributes.expiration_date"
                                    >
                                      <div class="text-caption nowrap">Fecha mínima de expiración</div>
                                      <div class="text-caption nowrap">{{ assignedLocation.presentation_atributes.expiration_date }}</div>
                                    </v-col>
                                    <v-col
                                      cols="6"
                                      class="pt-0"
                                      v-if="assignedLocation.presentation_atributes.product_presentation.product.tiene_control_de_calidad && assignedLocation.presentation_atributes.quality"
                                    >
                                      <div class="text-caption">Calidad</div>
                                      <div class="text-caption">{{ assignedLocation.presentation_atributes.quality.name }}</div>
                                    </v-col>
                                    <v-col
                                      cols="6"
                                      class="pt-0"
                                      v-if="
                                        assignedLocation.presentation_atributes.product_presentation.product.tiene_control_por_descriptivo_1 && assignedLocation.presentation_atributes.descriptivo_1
                                      "
                                    >
                                      <div class="text-caption">
                                        {{ getAliasName("descriptivo_1") }}
                                      </div>
                                      <div class="text-caption">{{ assignedLocation.presentation_atributes.descriptivo_1 }}</div>
                                    </v-col>
                                    <v-col
                                      cols="6"
                                      v-if="
                                        assignedLocation.presentation_atributes.product_presentation.product.tiene_control_por_descriptivo_2 && assignedLocation.presentation_atributes.descriptivo_2
                                      "
                                    >
                                      <div class="text-caption">
                                        {{ getAliasName("descriptivo_2") }}
                                      </div>
                                      <div class="text-caption">{{ assignedLocation.presentation_atributes.descriptivo_2 }}</div>
                                    </v-col>
                                    <v-col
                                      cols="6"
                                      class="pt-0"
                                      v-if="
                                        assignedLocation.presentation_atributes.product_presentation.product.tiene_control_por_descriptivo_3 && assignedLocation.presentation_atributes.descriptivo_3
                                      "
                                    >
                                      <div class="text-caption">
                                        {{ getAliasName("descriptivo_3") }}
                                      </div>
                                      <div class="text-caption">{{ assignedLocation.presentation_atributes.descriptivo_3 }}</div>
                                    </v-col>
                                    <v-col cols="6" class="pt-0" v-if="assignedLocation.presentation_atributes.storage_units_amount">
                                      <div class="text-caption">Almacenamiento</div>
                                      <div class="text-caption">{{ assignedLocation.presentation_atributes.storage_units_amount }}</div>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:no-results>
                  <v-alert :value="true" color="error" icon="warning">
                    {{ "Busqueda sin resultados - " + search }}
                  </v-alert>
                </template>
              </v-data-table>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="close()"> Cerrar </v-btn>
          <v-btn color="green darken-1" text @click="openDialogExpedir()"> Expedir LPNs Seleccionados </v-btn>
        </v-card-actions>
      </v-card>

      <ModalExpedir 
        :dialog="dialog_expedir" @updateDialog="dialog_expedir = false" :shipment_order="shipment_order" @shipedSuccess="shipedSuccess" 
        :lpns_to_ship="lpns_to_ship" 
        :lpns_to_unship="lpns_to_unship" :toast="toast" />
    </v-dialog>
  </div>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";
import { shipmentOrderService } from "@/libs/ws/shipmentOrderService";
import {lpnService} from "../../libs/ws/lpnService";
import AliasMixin from "../../mixins/AliasMixin";
import ModalExpedir from "@/views/ShipmentOrders/ModalExpedir.vue";
import GenericMixin from "@/mixins/GenericMixin.vue";

export default {
  components: { ModalExpedir },
  mixins: [AliasMixin,GenericMixin],
  props: {
    title: String,
    dialog_view: Boolean,
    shipment_order: Object,
    almacen: Number,
    code: Number,
    getPresentationTypeName: Function,
    isEmployee: Boolean,
    reloadList: Function,
  },
  data: () => ({
    list: [],
    formatUtils: formatUtils,
    defaultItem: null,
    loading: false,
    search: "",
    headers: [
      { title: "", align: "center", sortable: false, key: "expand", width: "60px" },      
      { text: "", value: "data-table-select", sortable: false, width: "40px" },
      { title: "LPN", align: "left", sortable: true, key: "lpn.code" },
      { title: "Estado", align: "left", sortable: true, key: "state.name" },
      { title: "Ubicación", align: "left", sortable: true, key: "ubicacion.code" },
    ],
    pagination: {
      page: 1,
      itemsPerPage: 5,
    },
    expandedRows: [],
    allExpanded: false,
    lpnService: lpnService,
    selected: [],
    dialog_expedir: false,
    lpns_to_ship: [],
    lpns_to_unship: [],
  }),
  created: function () {
    window.addEventListener("keydown", (e) => {
      if (e.key == "Escape") {
        this.close();
      }
    });
  },
  watch: {
    dialog_view(val) {
      if (val) {
        this.loadList();
      }
    },
  },
  mounted() {},
  methods: {
    updatePagination(pagination) {
      this.pagination = pagination;
    },
    close() {
      this.list = [];
      this.selected = [];
      this.expandedRows = [];
      this.allExpanded = false;
      this.$emit("closeDialog");
    },

    loadList() {
      if (!this.shipment_order || !this.shipment_order.id) {
        return;
      }
      
      this.loading = true;

      const param = {
        shipment_order: { id: this.shipment_order.id },
      };

      shipmentOrderService
        .get_lpns(param)
        .then((response) => {
          this.list = response.result.list;
          this.loading = false;
        })
        .catch((e) => {
          console.log("service.filter error");
          console.log(e);
          this.loading = false;
        });
    },

    getFilteredAssignedLocations(item) {
      // Filtrar assigned_locations por código de pedido
      if (!item.assigned_locations || !this.code) {
        return [];
      }

      return item.assigned_locations.filter((assignedLocation) => {
        return assignedLocation.shipment_order_item && assignedLocation.shipment_order_item.shipment_order && assignedLocation.shipment_order_item.shipment_order.code === this.code;
      });
    },

    toggleExpand(index) {
      const expandedIndex = this.expandedRows.indexOf(index);
      if (expandedIndex > -1) {
        this.expandedRows.splice(expandedIndex, 1);
      } else {
        this.expandedRows.push(index);
      }
    },

    isExpanded(index) {
      return this.expandedRows.includes(index);
    },

    toggleExpandAll() {
      if (this.allExpanded) {
        this.expandedRows = [];
      } else {
        this.expandedRows = this.list.map((item, index) => index);
      }
      this.allExpanded = !this.allExpanded;
    },
    toggleSelectAll(isSelected) {
      console.log("toggleSelectAll 2", isSelected);
      if (isSelected) {
        console.log("Seleccionar todo",isSelected,this.list);
        const selectableItems = this.list;
        this.selected = selectableItems.map((item) => item.lpn.id);
      } else {
        // Desmarcar todo
        this.selected = [];
      }
    },
    openDialogExpedir(item) {
      console.log("Abriendo modal expedir LPNs");
      //Listado de LPNs a expedir y a no expedir
      this.lpns_to_ship = [];
      this.lpns_to_unship = [];

      //lpns_to_ship son los selected, filtrarlos de this.list y los lpns_to_unship los que no estan en selected
      this.list.forEach((item) => {
        const lpnItem = this.selected.find((selectedLpnId) => item.lpn.id === selectedLpnId);
        
        if (lpnItem) {
          this.lpns_to_ship.push(item);
        }else{
          if(item.lpn.state.id != lpnService.STATE_SHIPPED)
            this.lpns_to_unship.push(item);
        }
      });

      this.dialog_expedir = true;
    },
    shipedSuccess(){
      this.close();
      this.$emit("reloadList");
    }
  },
};
</script>
